import { publicSearchApi, Site } from '@envato/foundation-types'
import get from 'lodash-es/get'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import { commaStyleString } from '../../../../common/utils/formatString'
import pushHistory from '../../../../common/utils/location/pushHistory'

import RadioSelector from './radioSelector'

interface IProps extends RouteComponentProps<any> {
  paramName: string
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  items?: publicSearchApi.IFilterOption[]
  labels?: any
  defaultSelectedValue?: string
}

interface IState {
  selectedOption: string
}

class FilterRadio extends React.Component<
  IProps & RouteComponentProps<any>,
  IState
> {
  public static defaultProps = { labels: {}, items: [] }
  private onChange: (event?: string) => void

  public constructor(props: IProps) {
    super(props)

    const { defaultSelectedValue = '' } = props

    this.state = {
      selectedOption: get(
        props,
        'locationParams.paramName',
        defaultSelectedValue
      )
    }
    this.onChange = this.onSelectionChange.bind(this)
  }

  public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    this.setState({
      selectedOption: nextProps.locationParams[this.props.paramName]
    })
  }

  public render() {
    return (
      <RadioSelector
        radioName={this.props.paramName}
        options={this.getOptionsWithLabels()}
        onChange={this.onChange}
        selectedValue={this.state.selectedOption}
      />
    )
  }

  private getOptionsWithLabels() {
    const { items = [], labels = {} } = this.props
    return items
      .filter(item => get(item, 'count', 0.1) > 0)
      .map(item => {
        return {
          value: item.key,
          label: item.label || get(labels, item.key) || item.key,
          count:
            typeof item.count !== 'undefined'
              ? commaStyleString(item.count, ',')
              : ''
        }
      })
  }

  private onSelectionChange(value: string) {
    const { locationParams, makeSearchLink, paramName, history } = this.props
    const query = {} as any
    query[paramName] = value

    let newQuery: ILocationParams
    newQuery = { ...locationParams, ...query }
    delete newQuery.page

    if (newQuery[this.props.paramName] === '') {
      delete newQuery[this.props.paramName]
    }

    this.setState({ selectedOption: value })

    pushHistory(history, makeSearchLink(newQuery) + '#content')
  }
}

export const FilterRadioComponent = FilterRadio
export default withRouter(FilterRadio)
